import React from 'react';
import { Clock, Users } from 'lucide-react';
import useInView from '../hooks/useInView';
import './PricingSection.css';

const PricingSection = () => {
  const { ref, isInView } = useInView();

  const pricing = [
    {
      duration: '45 Minuten',
      price: '100 €',
      icon: <Clock size={28} />
    },
    {
      duration: '60 Minuten',
      price: '120 €',
      icon: <Clock size={28} />
    },
    {
      duration: 'On-Field & Leistungschecks',
      price: 'auf Anfrage',
      icon: <Users size={28} />
    }
  ];

  return (
    <section
      id="preise"
      className={`pricing-section reveal-section ${isInView ? 'is-visible' : ''}`}
      ref={ref}
    >
      <div className="container">
        <div className="section-header reveal-item" style={{ '--reveal-delay': '0ms' }}>
          <h2 className="heading-2">Preise & Referenzen</h2>
        </div>

        <div className="pricing-container">
          <h3
            className="heading-3 reveal-item"
            style={{ marginBottom: 'var(--space-lg)', textAlign: 'center', '--reveal-delay': '80ms' }}
          >
            Preisliste
          </h3>
          <div className="pricing-grid">
            {pricing.map((item, index) => (
              <div
                key={index}
                className="pricing-card reveal-item"
                style={{ '--reveal-delay': `${140 + index * 80}ms` }}
              >
                <div className="pricing-icon">{item.icon}</div>
                <h4 className="body-large" style={{ fontWeight: 600, color: 'var(--primary-slate)' }}>
                  {item.duration}
                </h4>
                <div className="pricing-price">{item.price}</div>
              </div>
            ))}
          </div>

          <div className="pricing-info reveal-item" style={{ '--reveal-delay': '400ms' }}>
            <h4 className="heading-3" style={{ fontSize: '1.125rem', marginBottom: 'var(--space-md)' }}>Hinweis zur Abrechnung</h4>
            <p className="body-medium">
              Die Praxis ist eine Privatpraxis ohne Vertrag mit den Krankenkassen.
              Die Kosten werden zur Gänze von Ihnen selbst getragen. Je nach
              Zusatzversicherung können Teile der Behandlungskosten rückerstattet werden.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default PricingSection;
